import { doc, setDoc, serverTimestamp, increment } from "firebase/firestore";
import { db } from "../firebase";

export const activityService = {
	/**
	 * Increment active minutes for the current day for a user.
	 * Creates/merges a daily document keyed by `${userId}_YYYY-MM-DD`.
	 */
	async incrementActiveMinutes(
		userId: string,
		minutes: number = 1
	): Promise<void> {
		const now = new Date();
		const dayStart = new Date(now);
		dayStart.setHours(0, 0, 0, 0);
		const yyyy = dayStart.getFullYear();
		const mm = String(dayStart.getMonth() + 1).padStart(2, "0");
		const dd = String(dayStart.getDate()).padStart(2, "0");
		const id = `${userId}_${yyyy}-${mm}-${dd}`;

		const ref = doc(db, "userActivity", id);
		await setDoc(
			ref,
			{
				userId,
				dateId: `${yyyy}-${mm}-${dd}`,
				day: dayStart,
				minutes: increment(minutes),
				updatedAt: serverTimestamp(),
			},
			{ merge: true }
		);
	},

	startPageTimer(userId: string | null | undefined) {
		let handle: number | null = null;
		const tick = async () => {
			if (!userId) return;
			if (document.visibilityState !== "visible") return;
			await this.incrementActiveMinutes(userId, 1);
		};
		const start = () => {
			if (handle == null) handle = window.setInterval(tick, 60_000);
		};
		const stop = () => {
			if (handle != null) {
				window.clearInterval(handle);
				handle = null;
			}
		};
		const onVis = () =>
			document.visibilityState === "visible" ? start() : stop();
		document.addEventListener("visibilitychange", onVis);
		start();
		return () => {
			stop();
			document.removeEventListener("visibilitychange", onVis);
		};
	},
};
